import { styled } from 'dripsy';
import React from 'react';

import { BaseText, IBaseTextProps } from './BaseText';

const StyledText = styled(BaseText)({
  color: '$primary300',
  textDecorationLine: 'underline',
  fontWeight: 'semi',
});

export interface IBaseTextLinkProps extends IBaseTextProps {}

export function BaseTextLink(props: IBaseTextLinkProps) {
  return <StyledText {...props} />;
}
